export default "__VITE_ASSET__CjnEIE9E__"